export default "__VITE_ASSET__B57arj7Q__"